import Reveal from "../../components/ui/Reveal";
import PhoneMockup from "./PhoneMockup";
import { colors, fonts } from "../../constants/theme";

export default function ProtoApp() {
  return (
    <section
      id="app"
      style={{
        padding: "6.5rem 20px 6rem",
        background: "#050e08",
        position: "relative",
        overflow: "hidden"
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          #app {
            padding: 3.5rem 14px 4rem !important;
          }
          .proto-grid {
            grid-template-columns: 1fr !important;
            gap: 2.2rem !important;
            text-align: center !important;
          }
          .store-buttons { justify-content: center; }
          .store-button { flex: 1 1 205px; }
          .proto-grid h2 {
            font-size: clamp(1.8rem, 6.5vw, 2.5rem) !important;
          }
          .proto-grid p {
            font-size: 0.92rem !important;
            margin-bottom: 1.6rem !important;
          }
        }
      `}</style>
      {/* Background ambient radial glow */}
      <div style={{ position: "absolute", top: "20%", right: "-10%", width: 500, height: 500, background: `radial-gradient(circle, ${colors.lime}22 0%, transparent 70%)`, filter: "blur(60px)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: "10%", left: "-10%", width: 500, height: 500, background: `radial-gradient(circle, ${colors.mid}33 0%, transparent 70%)`, filter: "blur(60px)", pointerEvents: "none" }} />

      <div className="proto-grid" style={{ width: "min(1280px, 100%)", margin: "0 auto" }}>
        {/* Left: text + QR */}
        <div>
          <Reveal>
            <div style={{
              display: "inline-flex", alignItems: "center", gap: ".5rem",
              fontFamily: fonts.body, fontSize: ".75rem", fontWeight: 700,
              letterSpacing: ".14em", textTransform: "uppercase", color: colors.lime,
              marginBottom: ".8rem",
              background: "rgba(200, 241, 53, 0.1)",
              padding: ".35rem 1rem",
              borderRadius: 9999
            }}>
              Para iOS y Android
            </div>
          </Reveal>

          <Reveal delay={0.05}>
            <h2 style={{ fontFamily: fonts.display, fontSize: "clamp(2.2rem, 4vw, 3.5rem)", fontWeight: 800, color: "#ffffff", lineHeight: 1.1, marginBottom: "1.2rem" }}>
              Controla tu nutrición con la <span className="gradient-text">App VittaLink</span>
            </h2>
          </Reveal>

          <Reveal delay={0.08}>
            <p style={{ color: colors.gray, fontSize: "1.05rem", lineHeight: 1.75, maxWidth: 460, marginBottom: "2.2rem" }}>
              Conecta tu cuenta en segundos, realiza pagos remotos por QR, recibe sugerencias nutricionales con Inteligencia Artificial y ubica expendedoras cercanas.
            </p>
          </Reveal>

          {/* App store links */}
          <Reveal delay={0.12}>
            <div className="store-buttons" style={{ display: "flex", flexWrap: "wrap", gap: ".85rem" }}>
              <a className="store-button" aria-label="Buscar VittaLink en Google Play" href="https://play.google.com/store/search?q=VittaLink&c=apps" target="_blank" rel="noopener noreferrer" style={{ minWidth: 205, minHeight: 66, display: "inline-flex", alignItems: "center", gap: 12, padding: "12px 17px", borderRadius: 14, background: "#111713", border: "1px solid rgba(255,255,255,.16)", color: "#ffffff", textDecoration: "none" }}>
                <svg width="27" height="30" viewBox="0 0 28 32" aria-hidden="true"><path d="M2.2 1.7 16 16 2.2 30.3c-.5-.4-.8-1-.8-1.8V3.5c0-.8.3-1.4.8-1.8Z" fill="#34A853"/><path d="m16 16 4.3-4.5 5.6 3.2c1.1.6 1.1 1.6 0 2.2l-5.6 3.2L16 16Z" fill="#FBBC04"/><path d="M2.2 1.7c.6-.5 1.4-.5 2.3 0l15.8 9.8L16 16 2.2 1.7Z" fill="#4285F4"/><path d="m16 16 4.3 4.5L4.5 30.3c-.9.5-1.7.5-2.3 0L16 16Z" fill="#EA4335"/></svg>
                <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}><span style={{ fontSize: ".65rem", color: "#d1d7d2" }}>BUSCAR EN</span><span style={{ fontSize: "1.05rem", fontWeight: 700, marginTop: 3 }}>Google Play</span></span>
              </a>
              <a className="store-button" aria-label="Buscar VittaLink en App Store" href="https://apps.apple.com/search?term=VittaLink" target="_blank" rel="noopener noreferrer" style={{ minWidth: 205, minHeight: 66, display: "inline-flex", alignItems: "center", gap: 12, padding: "12px 17px", borderRadius: 14, background: "#111713", border: "1px solid rgba(255,255,255,.16)", color: "#ffffff", textDecoration: "none" }}>
                <svg width="27" height="30" viewBox="0 0 24 28" fill="currentColor" aria-hidden="true"><path d="M19.6 14.8c0-2.9 2.4-4.3 2.5-4.4a5.4 5.4 0 0 0-4.3-2.3c-1.8-.2-3.5 1.1-4.4 1.1-.9 0-2.3-1.1-3.8-1.1a5.7 5.7 0 0 0-4.8 2.9c-2.1 3.6-.5 8.8 1.5 11.7 1 1.4 2.1 3 3.6 2.9 1.4-.1 2-.9 3.8-.9 1.7 0 2.3.9 3.8.9 1.6 0 2.5-1.4 3.5-2.8a12.4 12.4 0 0 0 1.6-3.2 5 5 0 0 1-3-4.8Z"/></svg>
                <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}><span style={{ fontSize: ".65rem", color: "#d1d7d2" }}>BUSCAR EN</span><span style={{ fontSize: "1.05rem", fontWeight: 700, marginTop: 3 }}>App Store</span></span>
              </a>
            </div>
          </Reveal>
        </div>

        {/* Right: phone */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Reveal delay={0.15}>
            <PhoneMockup />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
